import React, { useContext, useEffect, useState } from 'react'
import { ErpClientContext } from '../services/erp'
import { message, Button } from 'antd'
import { sleep } from '@guillotinaweb/react-gmi'

export default function CheckPaymentMultiOrder(props) {
  const erpService = useContext(ErpClientContext)
  const id_multifactura = props.id_multifactura
  const id_factura = props.id_factura
  const [statusPayment, setStatusPayment] = useState(false)

  async function confirmPayment(id, id_factura) {
    const res = await erpService.fetch('/orders/@confirm-payment-multiorder', {
      method: 'POST',
      body: JSON.stringify({
        id_multifactura: id,
        id_factura: id_factura,
      }),
    })

    if (res.status === 200) {
      message.success('Invoice collected!')
      await sleep(2000)
      window.location.reload(false)
    } else {
      message.error(res.error.message)
    }
  }

  useEffect(() => {
    ;(async () => {
      const res = await erpService.fetch('/orders/@check-payment-multiorder', {
        method: 'POST',
        body: JSON.stringify({
          id_factura: id_factura,
        }),
      })

      if (res.status === 200) {
        const response = await res.json()
        setStatusPayment(response)
      }
    })()
  })

  return (
    <>
      <div
        style={{
          justifyContent: 'space-between',
          marginTop: 40,
        }}
      >
        <h2 className="title is-size-5">Confirm multiorder payment</h2>
        {statusPayment && (
          <p style={{ color: 'red' }}>Invoice already collected!</p>
        )}
        <Button
          disabled={statusPayment}
          onClick={() => confirmPayment(id_multifactura, id_factura)}
          type="default"
        >
          Confirm Payment
        </Button>
      </div>
    </>
  )
}
